import { getNumberPrivateTrainingCenterSaga } from './getNumberPrivateTrainingCenter'
import { getProfessionalInformationDataSaga } from './getProfessionalInformationData'
import { getProfessionnalInformationEtatiqueSaga } from './getProfessionnalInformationEtatique'
import { getProfessionalQualificationSaga } from './getProfessionalQualification'
import { getIdentityRegionaleEditiqueSaga } from './getIdentityRegionaleEditique'
import donneesEmploiSagas from './donneesEmploi'

const DataEditiqueSagas = [
    getNumberPrivateTrainingCenterSaga,
    getProfessionalInformationDataSaga,
    getProfessionnalInformationEtatiqueSaga,
    getProfessionalQualificationSaga,
    getIdentityRegionaleEditiqueSaga,
    ...donneesEmploiSagas,
]

export default DataEditiqueSagas
